import { useSearchParams } from "react-router-dom";
import { useMobileViewport } from "@/hooks/useMobileViewport";
import { QuestionnaireProvider } from "../context/QuestionnaireContext";
import { QuestionnaireAlert } from "./shared/QuestionnaireAlert";
import { QuestionnaireContent } from "./QuestionnaireContent";

export default function QuestionnaireDirectory() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  useMobileViewport();

  if (!token) {
    return (
      <QuestionnaireAlert
        title="questionnaires.errors.invalidLinkTitle"
        message="questionnaires.errors.invalidLinkMessage"
      />
    );
  }

  return (
    <QuestionnaireProvider token={token}>
      <QuestionnaireContent />
    </QuestionnaireProvider>
  );
}
